import React from 'react'
import { useAppDispatch } from '../../../hooks/redux/hooks';
import { logout } from '../authSlice';

const Logout = ({ text, template }: { text?: string, template?: 'Link' }) => {
  const dispatch = useAppDispatch();
  const defaultText = 'Sign out'
  const logoutHandler = () => {
    dispatch(logout());
  }

  if (template === 'Link') {
    return <a href="/" onClick={logoutHandler} className="link-primary fw-bolder link-opacity-75">{text ? text : defaultText}</a>
  }

  return (
    <div onClick={logoutHandler}>{text ? text : defaultText}</div>
  )
}

export default Logout